import { Box, Typography } from "@mui/material";
import React, { ReactNode, useCallback, useRef, useState } from "react";
import WhitePopperWithArrow from "./WhitePopperWithArrow";

type WhitePopperTooltipProps = {
	enabled: boolean;
	title?: ReactNode | string;
	forceOpen?: boolean;
	onOpenChange?: (open: boolean) => void;
};
const WhitePopperTooltip: React.FC<WhitePopperTooltipProps> = ({
	children,
	enabled,
	title,
	forceOpen,
	onOpenChange,
}) => {
	const [open, setOpen] = useState(false);
	const ref = useRef(null);

	const onOpen = useCallback(
		(open: boolean) => {
			setOpen(open);
			onOpenChange?.(open);
		},
		[onOpenChange]
	);

	if (!enabled) return <>{children}</>;

	return (
		<React.Fragment>
			<div ref={ref} onMouseEnter={() => enabled && onOpen(true)} onMouseLeave={() => enabled && onOpen(false)}>
				{children}
			</div>

			<WhitePopperWithArrow
				anchorEl={ref.current}
				open={open || Boolean(forceOpen)}
				toggleOpen={() => {
					setOpen((i) => !i);
					onOpenChange?.(!open);
				}}
			>
				<Box
					sx={{
						boxSizing: "border-box",
						backgroundColor: "surface.main",
						display: "flex",
						flexDirection: "column",
						padding: 3,
						borderRadius: 3,
						maxWidth: 241,
					}}
				>
					{typeof title === "string" ? <Typography variant="caption" children={title} /> : title}
				</Box>
			</WhitePopperWithArrow>
		</React.Fragment>
	);
};
export default WhitePopperTooltip;
